import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';

export default function Pending() {
  const { user, idToken, refreshSession } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function becomeFirstAdmin() {
    setBusy(true);
    setErr(null);
    try {
      await api('/api/me/bootstrap-admin', { method: 'POST', token: idToken ?? undefined });
      await refreshSession();
      location.assign('/');
    } catch (e: any) {
      setErr(e?.message ?? 'failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container" style={{ maxWidth: 540 }}>
      <div className="card">
        <h2>Pending admin approval</h2>
        <p>Hi <b>{user?.email}</b> — thanks for signing up. Your account is queued for review.</p>
        <p className="muted small">An admin will be notified. You'll receive an email when you're approved. You can also click below to check.</p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button onClick={() => refreshSession().then(() => location.reload())}>Check again</button>
          <button className="ghost" onClick={becomeFirstAdmin} disabled={busy}>
            {busy ? 'Working…' : 'I am the owner — make me admin'}
          </button>
        </div>
        {err && <p className="error small" style={{ marginTop: 12 }}>{err}</p>}
        <p className="muted small" style={{ marginTop: 12 }}>
          The owner button only works once: it succeeds for the first user when no admin has been provisioned yet, then is permanently disabled.
        </p>
      </div>
    </div>
  );
}
